import {
  NON_EXCLUSIVE,
  XLOLOI_COLLAB,
  SINGLE_PURCHASE,
  NON_COLLAB,
  HIDE_COLLAB,
  MANUAL_HIDE_COLLAB,
  NON_FILTER,
  USER_AUTH_COLLAB,
} from '../common/constant';
import tippy from 'tippy.js';

/*
 * Algolia Utility functions
 *
 * This script should be CENTER PLACE of defining
 * all custom logic related to Algolia Search like,
 * excluding 'COLOR BLOCK' and 'COLOR BLANKET',
 * Non-Collaborations in Collaboration value.
 **/

custom.algoliaUtils = (function () {
  /**
   * removeChoosenFacets
   * @params {object} hit - Algolia Collection result object
   * @access private
   * Looks through array of labels to remove facets from refinementList widgets
   */
  const removeChoosenFacets = (facetLabels = []) => {
    if (
      document.getElementsByClassName('ais-facets-wrapper').length <= 0 ||
      NON_FILTER.length <= 0
    )
      return;
    facetLabels.forEach((facet) => {
      const el = $('input[value="' + facet + '"]');
      el.closest('.ais-RefinementList--item').remove();
    });
  };

  /**
   * hitIsDiscontinued
   * @param {object} hit - Shopify product object
   * @returns {boolean} - Check if product is discontinued
   */
  const hitIsDiscontinued = (hit = {}) => {
    if (hit.named_tags && hit.named_tags.Discontinued) {
      if (typeof hit.named_tags.Discontinued === 'string') {
        return hit.named_tags.Discontinued.toUpperCase() == 'TRUE';
      }
      return true;
    }
    return false;
  };

  /**
   * collectionIsDiscontinued
   * @param {object} hit - Shopify collection object
   * @returns {boolean} - Check if collection is discontinued
   */
  const collectionIsDiscontinued = (hit = {}) => {
    if (hit.meta && hit.meta.loloi && hit.meta.loloi.discontinued) {
      if (typeof hit.meta.loloi.discontinued === 'string') {
        return hit.meta.loloi.discontinued.toUpperCase() == 'TRUE';
      }
      return true;
    }
    return false;
  };

  /**
   * getPillowSizeObject
   *
   * @param {object} hit - Shopify product object
   * - insert sizes and images data into hit object
   */
  const getPillowSizeObject = (data = {}) => {
    const sizeOps = data.product.options.filter(
      (option) => option.name == 'Size',
    )[0];
    if (!sizeOps) return;

    let sizes = [];
    sizeOps.values.forEach((size, index) => {
      const sameSizeVariants = data.product.variants
        .filter((variant) => variant.title.includes(size))
        .find((variant) => !!variant.image_id);

      const variantImgId = sameSizeVariants
        ? sameSizeVariants.image_id
        : `${data.product.id}_${index}`;
      const sizeImgUrl = sameSizeVariants
        ? data.product.images.find((image) => image.id == variantImgId).src
        : pillowNoImgSrc;

      sizes.push({
        size: size.replace(' PILLOW', '').replace(' POUF', '').toLowerCase(),
        image_id: variantImgId,
        image_url: custom.utils.getSpecificProductImage(sizeImgUrl, 258),
        image_url_retina: custom.utils.getSpecificProductImage(sizeImgUrl, 516),
        image_url_mobile: custom.utils.getSpecificProductImage(sizeImgUrl, 185),
        image_url_mobile_retina: custom.utils.getSpecificProductImage(
          sizeImgUrl,
          370,
        ),
      });
    });

    return sizes;
  };

  /**
   * getArtSizeObject
   *
   * @param {object} hit - Shopify product object
   * - insert sizes and images data into hit object
   */
  const getArtSizeObject = (data = {}) => {
    const sizeOps = data.product.options.filter(
      (option) => option.name == 'Size',
    )[0];
    if (!sizeOps) return;
    let sizes = [];
    sizeOps.values.forEach((size, index) => {
      const sameSizeVariants = data.product.variants
        .filter((variant) => variant.title.includes(size))
        .find((variant) => !!variant.image_id);
      const variantImgId = sameSizeVariants
        ? sameSizeVariants.image_id
        : `${data.product.id}`;
      const sizeImgUrl = sameSizeVariants
        ? data.product.images.find((image) => image.id == variantImgId).src
        : pillowNoImgSrc;
      if (sameSizeVariants) {
        sizes.push({
          size: size.toLowerCase(),
          image_id: variantImgId,
          image_url: custom.utils.getSpecificProductImage(sizeImgUrl, 258),
          image_url_retina: custom.utils.getSpecificProductImage(
            sizeImgUrl,
            516,
          ),
          image_url_mobile: custom.utils.getSpecificProductImage(
            sizeImgUrl,
            185,
          ),
          image_url_mobile_retina: custom.utils.getSpecificProductImage(
            sizeImgUrl,
            370,
          ),
        });
      } else if (index === 0) {
        if (data.product.image) {
          sizes.push({
            size: size.toLowerCase(),
            image_id: data.product.image.id
              ? data.product.image.id
              : data.product.id,
            image_url: data.product.image.src
              ? custom.utils.getSpecificProductImage(sizeImgUrl, 258)
              : pillowNoImgSrc,
            image_url_retina: data.product.image.src
              ? custom.utils.getSpecificProductImage(sizeImgUrl, 516)
              : pillowNoImgSrc,
            image_url_mobile: data.product.image.src
              ? custom.utils.getSpecificProductImage(sizeImgUrl, 185)
              : pillowNoImgSrc,
            image_url_mobile_retina: data.product.image.src
              ? custom.utils.getSpecificProductImage(sizeImgUrl, 370)
              : pillowNoImgSrc,
          });
        } else {
          //fallback, should not be happening on live site
          sizes.push({
            size: size.toLowerCase(),
            image_id: data.product.id,
            image_url: pillowNoImgSrc,
            image_url_retina: pillowNoImgSrc,
            image_url_mobile: pillowNoImgSrc,
            image_url_mobile_retina: pillowNoImgSrc,
          });
        }
      }
    });

    return sizes;
  };

  /**
   * getHoverImage
   *
   * @param {object} hit - Shopify product object
   * - find over image
   */
  const getHoverImage = (data = {}) => {
    const images = data.product.images;
    let hoverImg = false;
    if (images.length == 0) return hoverImg;
    const replace =
      data.product.product_type == 'RUGS' ? '_312x.jpg' : '_468x.jpg';
    const replace_retina =
      data.product.product_type == 'RUGS' ? '_624x.jpg' : '_936x.jpg';
    const replace_mobile =
      data.product.product_type == 'RUGS' ? '_224x.jpg' : '_335x.jpg';
    const replace_mobile_retina =
      data.product.product_type == 'RUGS' ? '_448x.jpg' : '_670x.jpg';
    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      if (!(typeof image.alt == 'undefined' || !image.alt)) {
        if (image.alt.toLowerCase() == 'hover') {
          hoverImg = {
            image: image.src.replace('.jpg', replace),
            image_retina: image.src.replace('.jpg', replace_retina),
            image_mobile: image.src.replace('.jpg', replace_mobile),
            image_mobile_retina: image.src.replace(
              '.jpg',
              replace_mobile_retina,
            ),
          };
          break;
        }
      }
    }
    return hoverImg;
  };

  /**
   * collectionImageMapper
   * @params {object} collection - Algolia Single Collection object
   * @params {object} i - Index Number
   * @params {object} products - Products in Collection
   * @access public
   */
  function collectionImageMapper(collection = {}, products = []) {
    // Set first product to main image key
    if (products[0] && products[0]['image']) {
      const mainImage = products[0]['image'];
      collection['mainImage'] = {
        desktop: custom.utils.getSpecificProductImage(mainImage, 228),
        desktopRetina: custom.utils.getSpecificProductImage(mainImage, 456),
        mobile: custom.utils.getSpecificProductImage(mainImage, 177),
        mobileRetina: custom.utils.getSpecificProductImage(mainImage, 354),
      };
    }
    // Push the products to an images key for rendering
    collection['images'] = products;
    if (collection['images'].length > 0) {
      collection['images'].forEach((product, index, arr) => {
        if (product.title) {
          arr[index]['handle'] = custom.utils.handleize(arr[index]['title']);
        }
        if (product.image) {
          arr[index]['thumbTablet'] = custom.utils.getSpecificProductImage(
            product.image,
            40,
          );
          arr[index]['thumb'] = custom.utils.getSpecificProductImage(
            product.image,
            60,
          );
          arr[index]['thumbTabletRetina'] =
            custom.utils.getSpecificProductImage(product.image, 80);
          arr[index]['thumbRetina'] = custom.utils.getSpecificProductImage(
            product.image,
            120,
          );
          arr[index]['image'] = custom.utils.getSpecificProductImage(
            product.image,
            177,
          );
          arr[index]['imageLarge'] = custom.utils.getSpecificProductImage(
            product.image,
            354,
          );
          arr[index]['desktop'] = custom.utils.getSpecificProductImage(
            product.image,
            228,
          );
          arr[index]['desktopRetina'] = custom.utils.getSpecificProductImage(
            product.image,
            456,
          );
        }
      });
    }

    return collection;
  }

  /**
   * collectionObjectReducer
   * @params {object} hit - Algolia Collection result object
   * @access private
   */
  function collectionObjectReducer(hit = {}) {
    // Collection Flag
    hit['isCollection'] = true;
    // isSingle - if only 1 product
    hit['isSingle'] = hit.products_count === 1 ? true : false;
    hit['discontinued'] = collectionIsDiscontinued(hit);
    // Indoor / Outdoor + Machine Washable
    if (hit.meta.loloi.style) {
      hit['indoorOutDoor'] = hit.meta.loloi.style == 'Indoor/Outdoor';
      hit['machineWashable'] = hit.meta.loloi.style == 'Machine Washable';
    }
    // Patent Pending
    if (hit.title) {
      hit['patentPending'] = hit.title.toUpperCase() == 'HERITAGE';
    }
    // Title Titlecasing
    if (hit['title']) {
      if (!hit['title'].includes('ED Ellen DeGeneres'))
        hit['title'] = custom.utils.titleCase(hit['title']);
    } else {
      hit['title'] = '';
    }
    // Collaboration handle
    if (
      hit.meta &&
      hit.meta.loloi &&
      hit.meta.loloi.collaboration &&
      !NON_COLLAB.includes(hit.meta.loloi.collaboration) &&
      !MANUAL_HIDE_COLLAB.includes(hit.meta.loloi.collaboration)
    ) {
      hit['collaboration_handle'] = custom.utils.handleize(
        hit.meta.loloi.collaboration,
      );
    }
    if (XLOLOI_COLLAB.includes(hit.meta.loloi.collaboration))
      hit.meta.loloi.collaboration += ' × Loloi';
    //HACK - Force specific line breaks
    if (
      hit.meta.loloi.collaboration === 'Magnolia Home by Joanna Gaines × Loloi'
    )
      hit.meta.loloi.collaboration =
        'Magnolia Home by Joanna&nbsp;Gaines&nbsp;×&nbsp;Loloi';
    if (XLOLOI_COLLAB.includes(hit.title)) hit.title += ' × Loloi';
    if (hit.meta && hit.meta.loloi && hit.meta.loloi.collaboration) {
      hit.hide_collab =
        HIDE_COLLAB.indexOf(hit.meta.loloi.collaboration) >= 0 ||
        MANUAL_HIDE_COLLAB.indexOf(hit.meta.loloi.collaboration) >= 0;
    }

    return hit;
  }

  /**
   * productObjectReducer
   * @params {object} hit - Algolia Product result object
   * @access private
   */
  function productObjectReducer(hit = {}) {
    // Formatted Price
    hit['formattedPrice'] = custom.utils.displayPrice(hit.price);
    // Titlecase Product Type
    hit['productTypeTitlecase'] = hit.product_type
      ? custom.utils.titleCase(hit.product_type)
      : hit.type
      ? custom.utils.titleCase(hit.type)
      : '';
    // Indoor / Outdoor + Machine Washable
    if (hit.named_tags && hit.named_tags.Style) {
      hit['indoorOutDoor'] = hit.named_tags.Style == 'Indoor/Outdoor';
      hit['machineWashable'] = hit.named_tags.Style == 'Machine Washable';
    }
    // Patent Pending
    if (hit.named_tags.Collection) {
      hit['patentPending'] =
        hit.named_tags.Collection.toUpperCase() == 'HERITAGE';
    }
    if (hit.image) {
      if (
        hit.product_type === 'PILLOWS' ||
        hit.product_type === 'WALL ART' ||
        hit.product_type === 'POUFS'
      ) {
        // Get medium size product image if pillow product
        hit['image'] = hit.image
          ? custom.utils.getSpecificProductImage(hit.image, 258)
          : null;
        hit['image_retina'] = hit.image
          ? custom.utils.getSpecificProductImage(hit.image, 516)
          : null;
        hit['image_mobile'] = hit.image
          ? custom.utils.getSpecificProductImage(hit.image, 185)
          : null;
        hit['image_mobile_retina'] = hit.image
          ? custom.utils.getSpecificProductImage(hit.image, 370)
          : null;
      } else {
        // Get smaller size product image for all else
        hit['image'] = hit.image
          ? custom.utils.getSpecificProductImage(hit.image, 258)
          : null;
        hit['image_retina'] = hit.image
          ? custom.utils.getSpecificProductImage(hit.image, 516)
          : null;
        hit['image_mobile'] = hit.image
          ? custom.utils.getSpecificProductImage(hit.image, 185)
          : null;
        hit['image_mobile_retina'] = hit.image
          ? custom.utils.getSpecificProductImage(hit.image, 370)
          : null;
      }
    }
    if (hitIsDiscontinued(hit)) {
      hit['isDiscontinued'] = true;
    }

    if (hit.meta && hit.meta.loloi && hit.meta.loloi.map_category) {
      if (hit.meta.loloi.map_category.toUpperCase() == 'NO MAP')
        hit['UnrestrictedMAP'] = true;
      if (hit.meta.loloi.map_category.toUpperCase() == 'MAP')
        hit['ProtectedMAP'] = true;
      if (
        hit.meta.loloi.map_category.toUpperCase() !== 'MAP' &&
        hit.meta.loloi.map_category.toUpperCase() !== 'NO MAP'
      )
        hit['mapNA'] = true;
    } else {
      hit['mapNA'] = true;
    }
    // Collection handle & name
    if (hit.named_tags && hit.named_tags.Collection) {
      hit.named_tags.Collection = custom.utils.titleCase(
        hit.named_tags.Collection,
      );
      hit['collection_handle'] = custom.utils.handleize(
        hit.named_tags.Collection,
      );
    }
    // Collaboration handle
    if (
      hit.named_tags &&
      hit.named_tags.Collaboration &&
      !NON_COLLAB.includes(hit.named_tags.Collaboration) &&
      !MANUAL_HIDE_COLLAB.includes(hit.named_tags.Collaboration)
    ) {
      let collaboration = hit.named_tags.Collaboration;
      if (Array.isArray(hit.named_tags.Collaboration)) {
        collaboration = hit.named_tags.Collaboration[0];
      }
      hit['collaboration_handle'] = custom.utils.handleize(collaboration);
    }

    if (XLOLOI_COLLAB.includes(hit.named_tags.Collaboration))
      hit.named_tags.Collaboration += ' × Loloi';

    //HACK - Force specific line breaks
    if (
      hit.named_tags.Collaboration === 'Magnolia Home by Joanna Gaines × Loloi'
    )
      hit.named_tags.Collaboration =
        'Magnolia Home by Joanna&nbsp;Gaines&nbsp;×&nbsp;Loloi';

    if (SINGLE_PURCHASE.includes(hit.named_tags.Collaboration)) {
      hit['sku'] = hit.sku;
      hit['objectID'] = hit.objectID;
      hit['isOneOfAKind'] = true;
      hit['oakSize'] = hit.variant_title;
      hit['oakPrice'] = hit.price;
      hit['authorized'] = collabAuthMapper(hit.authorized);
      let inCart = false;
      if (
        window.cartState &&
        window.cartState.cart &&
        window.cartState.cart.items &&
        window.cartState.cart.items.length > 0
      ) {
        for (let i = 0; i < window.cartState.cart.items.length; i++) {
          if (window.cartState.cart.items[0].product_id === hit.id) {
            inCart = true;
            break;
          }
        }
      }
      hit['isOAKInCart'] = inCart;
    }
    hit['productType'] = hit.product_type ? hit.product_type : null;
    // Product Type
    switch (hit.product_type) {
      case 'RUGS':
        hit['isRug'] = true;
        hit['hover_img'] = noHoverSrc;
        break;
      case 'PILLOWS':
        hit['isPillow'] = true;
        hit['hover_img'] = noHoverSrc;
        break;
      case 'RUG PADS':
        hit['isRugPad'] = true;
        break;
      case 'WALL ART':
        hit['isWallArt'] = true;
        hit['hover_img'] = noHoverSrc;
        break;
      case 'POUFS':
        hit['isPouf'] = true;
        hit['hover_img'] = noHoverSrc;
        break;
      case 'SAMPLE RACKS':
        hit['isRack'] = true;
        hit['hover_img'] = noHoverSrc;
        break;
      default:
        break;
    }

    return hit;
  }

  /**
   * resultObjectReducer
   * @params {object} hit - Algolia result object
   *
   */
  const resultObjectReducer = (hit = {}) => {
    return hit.products_count
      ? collectionObjectReducer(hit)
      : productObjectReducer(hit);
  };

  /**
   * productIsSingle
   * @params {object} hit - Check if product is single
   * Checks if purcahses should be limited to 1.
   */
  const productIsSingle = (hit = {}) => {
    if (hit.named_tags && hit.named_tags.Collaboration) {
      return SINGLE_PURCHASE.indexOf(hit.named_tags.Collaboration) >= 0;
    }

    return false;
  };

  /**
   * collabAuthMapper
   * @params {object} hit - Algolia product object
   * Add "nonExclusive" and "authorized" attributes.
   * Also checks if collaboration should be displayed, and if purcahses should be limited to 1.
   */
  const collabAuthMapper = (hit = {}) => {
    let collab = null;
    if (hit.named_tags && hit.named_tags.Collaboration) {
      collab = hit.named_tags.Collaboration.replace(/&nbsp;/g, ' ').replace(
        ' × Loloi',
        '',
      );
      hit.hideCollaboration =
        HIDE_COLLAB.indexOf(hit.named_tags.Collaboration) >= 0 ||
        MANUAL_HIDE_COLLAB.indexOf(hit.named_tags.Collaboration) >= 0;
      hit.singlePurchase =
        SINGLE_PURCHASE.indexOf(hit.named_tags.Collaboration) >= 0;
    }

    let nonExclusive = !collab || NON_EXCLUSIVE.includes(collab) ? true : false;
    let authorized =
      !collab || USER_AUTH_COLLAB.includes(collab) ? true : false;

    let construction =
      hit.named_tags && hit.named_tags.Construction
        ? hit.named_tags.Construction
        : '';

    return {
      ...hit,
      nonExclusive: nonExclusive,
      authorized: authorized,
      showExclusiveOrMap:
        !nonExclusive || !authorized || hit.UnrestrictedMAP || hit.ProtectedMAP,
      showCollectionOrCollaboration:
        hit.collection || (!hit.hideCollaboration && hit.collaboration),
      construction: construction,
    };
  };

  /**
   * headerTemplate
   * @params {object} item - The algolia object item
   * @params {string} title - The header title
   */
  const headerTemplate = (item, title) => {
    return item.refinedFacetsCount
      ? `${title} (${item.refinedFacetsCount})`
      : title;
  };

  /**
   * headerLabel
   * @params {string} attribute - The attribute to be filtered
   */
  const getHeaderLabel = (attribute, refinedCount) => {
    let headerLabel = 'Color';
    switch (attribute) {
      case 'meta.loloi.variant_option':
        headerLabel = 'Size & Shape';
        break;

      case 'named_tags.Material':
        headerLabel = 'Material';
        break;

      case 'named_tags.Style':
        headerLabel = 'Style';
        break;

      case 'named_tags.Collaboration':
        headerLabel = 'Brands';
        break;

      case 'named_tags.Construction':
        headerLabel = 'Construction';
        break;

      case 'meta.loloi.frame_filter':
        headerLabel = 'Frame';
        break;

      case 'meta.loloi.orientation_filter':
        headerLabel = 'Orientation';
        break;

      case 'named_tags.Frame':
        headerLabel = 'Frame';
        break;

      case 'named_tags.Orientation':
        headerLabel = 'Orientation';
        break;

      case 'product_type':
        headerLabel = 'View By';
        break;

      case 'meta.loloi.map_category':
        headerLabel = 'MAP Policy';
        break;

      default:
        break;
    }
    return `${headerLabel}${refinedCount ? ` (${refinedCount})` : ''}`;
  };

  /**
   * itemTemplate
   * @params {object} item - refinement item
   */
  const itemTemplate = (item) => {
    const { label, count, isRefined, value } = item;
    let textLabel, countLabel;
    //Label should always be capitalized
    if (label) {
      textLabel = custom.utils.titleCaseWithExceptions(label);
    }
    countLabel = count
      ? ` <span class="ais-RefinementList--count utility-xsmall text-grey-4">(${count})</span>`
      : '';
    const safeValue = value.replace(/"/g, '&quot;');
    // don't display N/A
    if (label.toUpperCase() == 'N/A') {
      return;
    }
    // add custom labels for MAP
    if (label.toUpperCase() == 'NO MAP') {
      textLabel = `Unrestricted by MAP <span class="tippy-container tippy-container--algolia-filter inline">
                  <span class="tippy-icon inline-block relative js-tippy-map" title="No MAP (Minimum Advertised Price) means merchants can advertise this product at any price. This product is often sold via online retailers at a competitive price.<p><a href='/pages/faq#faqOrdering3' target='_blank'>Learn More</a></p>"><span class="inline-block border border-primary rounded-full w-4 h-4 text-center">?</span></span>
                </span>`;
      countLabel = '';
    }
    if (label.toUpperCase() == 'MAP') {
      textLabel = `Protected by MAP <span class="tippy-container tippy-container--algolia-filter inline">
                  <span class="tippy-icon inline-block relative js-tippy-map" title="MAP (Minimum Advertised Price) helps enable a consistent minimum price across all sellers.<p><a href='/pages/faq#faqOrdering3' target='_blank'>Learn More</a></p>"><span class="inline-block border border-primary rounded-full w-4 h-4 text-center">?</span></span>
                </span>`;
      countLabel = '';
    }
    return `<div class="ais-RefinementList--item js-gtm ${
      isRefined ? 'ais-RefinementList--item__active' : ''
    }"><label class="ais-RefinementList--label inline-block" data-refined="${isRefined}" data-value="${safeValue}">
    <input type="checkbox" class="ais-RefinementList--checkbox" value="${safeValue}" ${
      isRefined ? 'checked' : ''
    }>
    <div class="relative">${textLabel}${countLabel}
    </div>
    <span class="ais-RefinementList--checkmark"></span>
    </label></div>`;
  };

  /**
   * itemTemplate
   * @params {object} item - refinement item
   */
  const rugsSizeTemplate = (items) => {
    const categories = [
      {
        name: 'Rectangular',
        values: [
          'Oversized',
          '12 x 15',
          '10 x 14',
          '9 x 12',
          '8 x 10',
          '6 x 9',
          '5 x 8',
          '4 x 6',
          '2 x 3',
          "12' x 15'+",
          "12' x 15'",
          "10' x 14'",
          "9' x 12'",
          "8' x 10'",
          "6' x 9'",
          "5' x 8'",
          "4' x 6'",
          "2' x 3'",
        ],
      },
      {
        name: 'Square & Round',
        values: [
          "10'+ Square",
          "7'-9' Square",
          '7-9 Square',
          "7'+ Round",
          "7' + Round",
          '7+ Round',
          "5'-6' Round",
          '5-6 Round',
          "3'-4' Round",
          '3-4 Round',
        ],
      },
      {
        name: 'Runners',
        values: [
          "14'+ Runner",
          "14'+runner",
          "12' Runner",
          "10' Runner",
          "8' Runner",
          "2.6' x 12'+",
          "2.6' x 10'",
          "2.6' x 8'",
          '2.6 x 12+',
          '2.6 x 10',
          '2.6 x 8',
        ],
      },
      {
        name: 'Samples',
        values: [
          '18" Sample',
          'Available in 18" sample',
          '18" Square',
          "18' Sample",
          "Available in 18' sample",
          "18' Square",
        ],
      },
    ];
    let refinementFacets = '';
    let priorCategoryExists = false;
    categories.forEach((category) => {
      const categoryFacets = items
        .filter((item) => {
          return category.values.includes(item.label);
        })
        .sort(
          (a, b) =>
            category.values.indexOf(a.label) - category.values.indexOf(b.label),
        );

      if (categoryFacets.length > 0) {
        refinementFacets += `<p class="rug-size-category tracking-075 block w-full pl-2 mb-2 ${
          priorCategoryExists ? 'mt-4' : ''
        }">${category.name}</p>`;
        refinementFacets += categoryFacets
          .map((item) => {
            return itemTemplate(item);
          })
          .join('');
        priorCategoryExists = true;
      }
    });
    // Add leftover items that are not in the above categories to an "Other" section that ideally should be empty
    // This is to catch any sizes that are not in the above categories
    const leftoverItems = items.filter(
      (item) => !categories.flatMap((cat) => cat.values).includes(item.label),
    );

    if (leftoverItems.length > 0) {
      refinementFacets += `<p class="utility-xsmall utility-xsmall--emphasis tracking-075 block w-full pl-2 my-4">Other</p>`;
      refinementFacets += leftoverItems
        .map((item) => {
          return itemTemplate(item);
        })
        .join('');
    }
    return refinementFacets;
  };

  /**
   * colorTemplate
   * @params {object} item - color item
   */
  const colorTemplate = (item) => {
    const { label, count, isRefined } = item;
    const endSection = isRefined
      ? '<span class="color-close"></span>'
      : `<span class="text-grey-4">${count ? '(' + count + ')' : ''}</span>`;
    const capitalizedLabel = label
      ? label.charAt(0).toUpperCase() + label.slice(1)
      : '';

    return `<div class="ais-RefinementList--item js-gtm ${
      isRefined ? 'ais-RefinementList--item__active' : ''
    }"><label tabindex="0" for="color-${item.value}" class="${
      isRefined ? 'refined' : ''
    } color-holder cursor-pointer" title="${capitalizedLabel} (${count})" data-value="${
      item.value
    }">
        <input id="color-${item.value}" type="checkbox" class="hidden" value="${
      item.value
    }" ${isRefined ? 'checked' : ''}>
          <span class="color-${capitalizedLabel} color-refinement">${capitalizedLabel} (${count})</span>
          <span class="color-label">${capitalizedLabel} ${endSection}</span>
        </label></div>`;
  };

  /**
   * productTypeTemplate
   * @params {object} item - product type
   */
  const productTypeTemplate = (item) => {
    const { label, count, isRefined } = item;
    return `<div class="product-type-item js-gtm ${
      isRefined ? 'product-type-item--active' : ''
    }"><label class="${
      isRefined ? 'refined' : ''
    } product-type-holder mt-2 cursor-pointer" title="${label} (${count})" data-value="${
      item.value
    }">
        <input type="checkbox" class="hidden" value="${item.value}" ${
      isRefined ? 'checked' : ''
    }>
          <span class="product-type-label w-full align-baseline capitalize ${
            isRefined ? 'refined title-medium' : 'title-small'
          }">${
      label ? label.toLowerCase() : ''
    }<span class="product-type-count utility-xsmall ml-2">${
      count ? '(' + count + ')' : ''
    }</span></span>
        </label></div>`;
  };

  /**
   * getSizeNum
   * @params {str} sizeStr - Size of string formatted as inch x inch
   * Sort out variants from small to big.
   * NOTE: Since all Wall Art OAK has "S", "M", "L", "XL" as size variant,
   * assign those to integer here to absorb that exception
   */
  function getSizeNum(sizeStr) {
    if (!sizeStr) return 0;
    // S, M, L, XL Exception Handler
    if (sizeStr === 'S') return 100;
    if (sizeStr === 'M') return 200;
    if (sizeStr === 'L') return 300;
    if (sizeStr === 'XL') return 400;

    // For OAK Rugs Filter Order
    const runner = ' runner';
    const gallery = 'gallery';
    if (sizeStr.toLowerCase().includes(gallery)) return 1000;
    if (sizeStr.toLowerCase().includes(runner)) {
      let run_arr = sizeStr.split(runner);
      run_arr[0].replace('+', '');
      return parseInt(run_arr[0]) + 500;
    }

    const giantSizes = ['Oversized'];
    if (giantSizes.indexOf(sizeStr) >= 0) return 1000;
    let wh_arr = sizeStr.toLowerCase().split(' x ');
    if (
      wh_arr[0].indexOf('" r') > -1 ||
      wh_arr[0].indexOf('round') > -1 ||
      wh_arr[0].indexOf('square') > -1 ||
      wh_arr[0].indexOf('oval') > -1
    ) {
      wh_arr.push(wh_arr[0]);
    }
    if (wh_arr.length <= 1) return 0;
    wh_arr = wh_arr.map((inch) => {
      if (inch.indexOf(`"`) > 0) inch = inch.substr(0, inch.indexOf(`"`));
      //convert feet to inches
      if (inch.indexOf(`'-`) > 0) {
        let inch_arr = inch.split(`'-`);
        inch = parseInt(inch_arr[0]) * 12 + parseInt(inch_arr[1]);
      } else {
        if (inch.indexOf(`'`) > 0) {
          let inch_arr = inch.split(`'`);
          inch = parseInt(inch_arr[1])
            ? parseInt(inch_arr[0]) * 12 + parseInt(inch_arr[1])
            : parseInt(inch_arr[0]) * 12;
        }
      }

      return parseFloat(inch);
    });
    return wh_arr[0] * wh_arr[1];
  }
  /**
   * variantSorter
   * @params {object} variants - All variants in product
   * Sort out variants from small to big.
   */
  const variantSorter = (variants = {}) => {
    function getSizeStr(variant) {
      return variant.element.dataset.size
        ? variant.element.dataset.size
        : variant.text;
    }
    return variants.sort(function (a, b) {
      return getSizeNum(getSizeStr(a)) - getSizeNum(getSizeStr(b));
    });
  };
  /**
   * variantsCount
   * @params {object} hit - Algolia product object
   * Add "singleVariant" attribute used for quick panel size dropdown
   */
  const variantsCount = (hit = {}) => {
    return {
      ...hit,
      singleVariant: hit.variants_count === 1 ? true : false,
    };
  };

  /**
   * updateFiltersBar
   * @params {integer} count - Number of facets applied
   */
  const updateFiltersBar = (count = 0) => {
    if (count > 0) {
      $('.product-showcase').addClass('product-showcase--has-filters');
      $('.product-showcase__filter-and-sort-count').text(`(${count}) `);
    } else {
      $('.product-showcase').removeClass('product-showcase--has-filters');
      $('.product-showcase__filter-and-sort-count').text('');
    }
  };

  /**
   * updateDoorwayDriver
   * @description - Updates the doorway driver for Algolia search results on PLP pages
   * @params {integer} count - Number of facets applied
   */
  const updateDoorwayDriver = (count = 0) => {
    if (!$('.js-plp-doorway-driver').length) return;
    if (count > 0) {
      $('.js-plp-doorway-driver')
        .not('.js-plp-doorway-driver--non-plp')
        .addClass('plp-doorway-driver--has-filters');
    } else {
      $('.js-plp-doorway-driver').removeClass(
        'plp-doorway-driver--has-filters',
      );
    }
  };

  /**
   * refreshTippy
   * Refreshes tippy tooltips for MAP items
   */
  const refreshTippy = () => {
    setTimeout(function () {
      const isMobile = $(window).width() < 768;
      const isTablet = $(window).width() < 1024;

      if (isTablet) {
        tippy('.js-tippy-map', {
          animation: 'fade',
          appendTo: document.body,
          arrow: true,
          arrowTransform: 'scaleX(0.75)',
          placement: isMobile ? 'top' : 'top-end',
          offset: '62, 0',
          maxWidth: '238px',
          maxHeight: '81px',
          interactive: true,
        });
      } else {
        tippy('.js-tippy-map', {
          animation: 'fade',
          appendTo: document.body,
          arrow: true,
          arrowTransform: 'scaleX(0.75)',
          placement: 'top',
          maxWidth: '238px',
          maxHeight: '81px',
          interactive: true,
        });
      }
    }, 500);
  };

  return {
    hitIsDiscontinued,
    collectionIsDiscontinued,
    removeChoosenFacets,
    getPillowSizeObject,
    getArtSizeObject,
    getHoverImage,
    collectionImageMapper,
    resultObjectReducer,
    productIsSingle,
    collabAuthMapper,
    getSizeNum,
    headerTemplate,
    getHeaderLabel,
    itemTemplate,
    rugsSizeTemplate,
    colorTemplate,
    productTypeTemplate,
    variantSorter,
    variantsCount,
    updateFiltersBar,
    updateDoorwayDriver,
    refreshTippy,
  };
})();

// EXPORT to window object to be used in autocomplete.js
window.AlgoliaUtils = custom.algoliaUtils;



// WEBPACK FOOTER //
// ./src/scripts/src/custom/algolia-utils.js